import { apiCall } from './api';

/**
 * Frontend handoff contract for the backend team.
 *
 * Replace the local implementations below with authenticated API requests while
 * preserving the returned shapes used by the catalogue and workspace pages.
 */
export const SUPERNOVA_TOOLS_API_CONTRACT = Object.freeze({
  catalogue: 'GET /api/supernova-tools',
  tool: 'GET /api/supernova-tools/:slug',
  run: 'POST /api/supernova-tools/:slug/runs',
});

/**
 * `GET /api/supernova-tools/:slug` should return this showcase structure.
 * The CMS owns content and URLs; the embedded project owns its own interface.
 */
export const SUPERNOVA_TOOL_SHOWCASE_CONTRACT = Object.freeze({
  about: 'string',
  embed: {
    src: 'same-origin path or http(s) URL',
    title: 'accessible iframe title',
    height: 'number',
    sandbox: 'space-separated iframe sandbox permissions',
    allow: 'iframe permissions policy',
  },
  actions: [
    {
      id: 'string',
      kind: 'external | download | internal',
      label: 'string',
      href: 'same-origin path or http(s) URL',
      icon: 'optional ToolGlyph name',
      downloadName: 'optional filename',
    },
  ],
});

export const listSupernovaTools = async ({ signal } = {}) => {
  const response = await apiCall('/supernova-tools', { signal });

  if (!Array.isArray(response?.data)) {
    throw new Error('The tool catalogue response is invalid.');
  }

  return response;
};

export const getSupernovaTool = async (slug, { signal } = {}) => {
  const response = await apiCall(`/supernova-tools/${encodeURIComponent(slug)}`, {
    signal,
  });

  if (!response?.data || Array.isArray(response.data)) {
    throw new Error('The tool response is invalid.');
  }

  return response;
};
